import React, { createContext, useContext, useState, useEffect } from 'react';
import apiService from '../services/nextlevelgames-api';

const StoreContext = createContext(null);

export const StoreProvider = ({ children }) => {
  const [locations, setLocations] = useState([]);
  const [selectedLocation, setSelectedLocationState] = useState(() => {
    try {
      const stored = localStorage.getItem('nlg_selected_location');
      return stored ? JSON.parse(stored) : null;
    } catch {
      return null;
    }
  });

  useEffect(() => {
    apiService.getLocations().then(data => {
      const locs = Array.isArray(data) ? data : (data.locations || []);
      setLocations(locs);
      // If stored location no longer exists in the list, clear it
      if (selectedLocation) {
        const stillValid = locs.some(l => l.id === selectedLocation.id);
        if (!stillValid) setSelectedLocationState(null);
      }
    }).catch(() => {});
  }, []);

  const setSelectedLocation = (location) => {
    setSelectedLocationState(location);
    if (location) {
      localStorage.setItem('nlg_selected_location', JSON.stringify(location));
    } else {
      localStorage.removeItem('nlg_selected_location');
    }
  };

  return (
    <StoreContext.Provider value={{ locations, selectedLocation, setSelectedLocation }}>
      {children}
    </StoreContext.Provider>
  );
};

export const useStore = () => useContext(StoreContext);
